import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Breadcrumb } from './breadcrumb.types';
import { company } from '../system/company.types';
import { Router } from '@angular/router';
import { User_Service } from '../user/user.service';
import { branch } from '../system/branch.types';
import { api_response } from 'app/shared/shared.types';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class Navigation_Service {
    private _search: ReplaySubject<any> = new ReplaySubject<any>(1);
    private _company: ReplaySubject<company> = new ReplaySubject<company>(1);
    private _branch: ReplaySubject<company> = new ReplaySubject<company>(1);

    private _breadcrumb: ReplaySubject<Breadcrumb> = new ReplaySubject<Breadcrumb>(1);

    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    public company: company;
    public branch: branch;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _router: Router,
        private _us: User_Service
    ) {
        this.company$.subscribe((company: company) => { this.company = company });
        this.branch$.subscribe((branch: branch) => { this.branch = branch });

        this._breadcrumb.next(
            {
                "title": "Dashboard",
                "crumbs": [],
                "search": false
            }
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }
    get breadcrumb$(): Observable<Breadcrumb> {
        return this._breadcrumb.asObservable();
    }
    get company$(): Observable<company> {
        return this._company.asObservable();
    }
    get branch$(): Observable<company> {
        return this._branch.asObservable();
    }
    get search$(): Observable<string> {
        return this._search.asObservable();
    }

    // set company(value: any) {
    //     this._company.next(value);
    // }
    // set branch(value: any) {
    //     this._branch.next(value);
    // }
    set breadcrumb(value: any) {
        this._breadcrumb.next(value);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<api_response<any>> {
        return this._httpClient
            .post('api/dashboard/navigation', {
                access_token: localStorage.getItem('access_token')
            })
            .pipe(
                tap((response: api_response<any>) => {
                    //TODO:: CATCHING ERROR
                    // if (response.code == 401) {
                    //     alert("LOGIN");
                    // }
                    this._company.next(response.payload.selected[0]);
                    this._branch.next(response.payload.selected[1]);
                    this._navigation.next(response.payload);
                })
            );
    }

    /**
     * Get all navigation data
     */
    switch_company(item: any) {
        return this._httpClient
            .post('api/dashboard/navigation', {
                access_token: localStorage.getItem('access_token'),
                type: "company",
                selection: item.id
            }).subscribe((response: api_response<any>) => {
                //TODO:: CATCHING ERROR
                // if (response.code == 401) {
                //     alert("LOGIN");
                // }
                this._company.next(response.payload.selected[0]);
                this._branch.next(response.payload.selected[1]);
                this._navigation.next(response.payload);
            });
    }

    switch_branch(item: any) {
        return this._httpClient
            .post('api/dashboard/navigation', {
                access_token: localStorage.getItem('access_token'),
                type: "branch",
                selection: item.id
            }).subscribe((response: api_response<any>) => {
                //TODO:: CATCHING ERROR
                // if (response.code == 401) {
                //     alert("LOGIN");
                // }
                this._company.next(response.payload.selected[0]);
                this._branch.next(response.payload.selected[1]);
                this._navigation.next(response.payload);
            });
    }

    search(text: any) {
        this._search.next(text);
    }

    go_to(url: string) {
        this._router.navigate([url]);
    }

    bounce_from(url: string) {
        window.open(environment.api_url + url, "_self");
    }

    bounce_to(url: string) {
        window.open(window.location.href + url, "_blank");
    }

    download(url: string) {
        window.open(environment.cdn_url + url, "_blank");
    }

    access(level: number, log: string = null) {
        //TODO:: CORRECT ACCESS
        return true;
        let access = this._us.current.role <= level;
        if (log) {
            console.log(log + " Level:" + level + " Role:" + this._us.current.role + " Access:" + access);
        }
        return access;
    }
}
